module.exports = __webpack_public_path__ + "static/media/react.84d44aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/home/images/react.png
// module id = 530
// module chunks = 8